"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var AcceptPolicy_1 = require("../AcceptPolicy");
var useInitialValues_1 = require("../useInitialValues");
var useValidateSchema_1 = require("../useValidateSchema");
var Country_1 = __importDefault(require("./Country"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SignUpForm = function (_a) {
    var _b = _a.withLabels, withLabels = _b === void 0 ? true : _b, welcomeFields = _a.welcomeFields, authInputMode = _a.authInputMode, onSubmit = _a.onSubmit;
    var initialValues = (0, useInitialValues_1.useInitialValues)();
    var lang = (0, next_intl_1.useLocale)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var backUrl = searchParams.get('back');
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var validateSchema = (0, useValidateSchema_1.useValidateSchema)({ welcomeFields: welcomeFields });
    var currencies = (0, swr_hooks_1.useGenerateCurrencies)();
    var signInUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_IN_MODAL, true);
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var openModal = (0, apps_shared_1.useOpenModal)();
    var params = (0, navigation_1.useSearchParams)();
    var code = params.get('code') || undefined;
    var router = (0, navigation_1.useRouter)();
    var _c = (0, swr_hooks_1.useSignUp)({
        successAction: function () {
            if (backUrl)
                router.push(backUrl);
            else {
                closeModal();
                openModal(apps_shared_1.POPUP_CONSTANTS.DEPOSIT);
            }
        },
    }), signUp = _c.signUp, isSubmitting = _c.isSubmitting, error = _c.error;
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var affiliateData = typeof window !== 'undefined' ? Lockr.get('affiliate') : null;
        var inviteData = Lockr.get('invite');
        var newDate = (affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.date)
            ? (0, date_fns_1.addDays)(new Date(affiliateData.date), 7)
            : new Date();
        var isExpiredAffDate = (0, date_fns_1.isAfter)(new Date(), newDate);
        signUp({
            email: values.email,
            password: values.password,
            currency: (_a = values.currency) === null || _a === void 0 ? void 0 : _a.value,
            country: (_b = values.country) === null || _b === void 0 ? void 0 : _b.value,
            nickname: values.nickname ? values.nickname : undefined,
            receivePromos: true,
            partnerId: !isExpiredAffDate && ((_c = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _c === void 0 ? void 0 : _c.partnerId)
                ? Number((_d = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _d === void 0 ? void 0 : _d.partnerId)
                : undefined,
            offerId: !isExpiredAffDate && ((_e = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _e === void 0 ? void 0 : _e.offerId)
                ? Number((_f = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _f === void 0 ? void 0 : _f.offerId)
                : undefined,
            clickId: !isExpiredAffDate && ((_g = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _g === void 0 ? void 0 : _g.clickId)
                ? String((_h = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _h === void 0 ? void 0 : _h.clickId)
                : undefined,
            partnerType: !isExpiredAffDate && ((_j = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _j === void 0 ? void 0 : _j.type)
                ? String((_k = affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.data) === null || _k === void 0 ? void 0 : _k.type)
                : undefined,
            referralCode: (inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                ? String(inviteData === null || inviteData === void 0 ? void 0 : inviteData.invite)
                : undefined,
            language: lang ? lang : undefined,
            code: code,
        });
    }, [signUp, lang, code]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmit || onSubmitHandler, initialValues: initialValues, validate: (0, apps_shared_1.formValidator)(validateSchema), render: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting, form = _a.form;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_final_form_1.Field, { name: "email", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: "user@gmail.com", labelText: withLabels ? t('email') : undefined, helperButton: meta.error && meta.touched && { type: 'error' } })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } }),
                        welcomeFields.includes('nickname') ? (react_1.default.createElement(react_final_form_1.Field, { name: "nickname", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: t('enterNickname'), labelText: t('nickname'), hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } })) : null,
                        react_1.default.createElement(react_final_form_1.Field, { name: "password", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputPassword, __assign({}, input, { mode: authInputMode, placeholder: t('enterPassword'), labelText: withLabels ? t('password') : undefined, hasError: meta.error && meta.touched })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } }),
                        react_1.default.createElement(Country_1.default, { authInputMode: authInputMode, withLabels: withLabels }),
                        react_1.default.createElement(react_final_form_1.Field, { name: "currency", render: function (_a) {
                                var _b;
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputSelect, __assign({}, input, { mode: authInputMode, options: currencies, labelText: withLabels ? t('currency') : undefined, placeholder: t('selectCurrency'), hasError: meta.error && meta.touched, isDisabled: !currencies.find(function (item) { return item.value !== input.value.value; }) })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
                            } }),
                        react_1.default.createElement(ui_components_1.CurrencySelectNotification, null),
                        react_1.default.createElement(AcceptPolicy_1.AcceptPolicy, null),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.mainErrorWrapper }, error && react_1.default.createElement(ui_components_1.ErrorText, null, tErr(error))),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                            react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", loading: isSubmitting || submitting, text: "upper" }, t('signup'))),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.centerLinkWrapper },
                            react_1.default.createElement(ui_components_1.TextLink, { href: signInUrl }, t('login'))))));
            } })));
};
exports.default = SignUpForm;
